import React from 'react';
import { WtUi } from 'wt-ui';
import PropTypes from 'prop-types';
import ErrorBoundary from '../../components/ErrorBoundary';
import VariationContext from '../../services/VariationContext';
import Main from '../Main';

const App = ({ configVariation }) => (
  <WtUi>
    <div id="app_version" style={{ display: 'none' }}>
      {process.env.REACT_APP_VERSION}
    </div>
    <div id="commit_hash" style={{ display: 'none' }}>
      {process.env.REACT_APP_COMMIT_HASH}
    </div>
    <ErrorBoundary>
      <VariationContext.Provider value={configVariation}>
        <Main />
      </VariationContext.Provider>
    </ErrorBoundary>
  </WtUi>
);

App.defaultProps = {
  configVariation: 'embedded',
};

App.propTypes = {
  configVariation: PropTypes.string,
};

export default App;
